import React, { useState, useEffect, useRef } from "react";
import "./Donations.scss";
import {
  Table,
  Button,
  Input,
  Tooltip,
  Modal,
  Divider,
  notification,
  Spin,
} from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Col, DatePicker, Drawer, Form, Row, Select, Space } from "antd";
import {
  allDonations,
  deleteDonations,
  donationReceipt,
} from "../../../apis/DonationApi";
import { Toolbar } from "primereact/toolbar";
import DonationForm from "./donationForm";
import { paginatedDonations } from "../../../apis/DonationApi";
import { useNavigate } from "react-router-dom";
import { downloadDonationReceiptFile } from "../../../functions/functions";
import { allCycles } from "../../../apis/CycleApi";

const Context = React.createContext({
  name: "Default",
});

const Donations = () => {
  const { Search } = Input;
  const toast = useRef(null);
  const moment = require("moment");
  const [donations, setDonations] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [modal2Open, setModal2Open] = useState(false);
  const { Option } = Select;
  const [currentRecordId, setCurrentRecordId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [donorName, setDonorName] = useState("");
  const [isloading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filteredDonations, setFilteredDonations] = useState([]);
  //cycle are called here in a use state
  const [cycleData, setCycleData] = useState([]);
  const [cycleNames, setCycleNames] = useState([]);
  const [pageSize, setPageSize] = useState(10);
const [currentPage, setCurrentPage] = useState(0);
const [totalCount, setTotalCount] = useState(0);
 const [sortField, setSortField] = useState("creationDate");
const [sortDirection, setSortDirection] = useState("desc");
const [selectedCycleFilter, setSelectedCycleFilter] = useState(null);
const [searchQuery, setSearchQuery] = useState("");
  const [currentRecord, setCurrentRecord] = useState(null);

  const confirmDelete = (id) => {
    deleteDonations(id).then((res) => {
      if (res.status === 200) {
        const heading = "Donation Deleted Successfully !";
        const message = "Donation has been deleted successfully !";
        openNotification("bottomRight", "success", heading, message);
        loadAllDonations();
        setModal2Open(false);
      } else {
        const heading = "Donation Deletion Unsuccessful !";
        const message = `Donation could not be deleted. Please try again`;
        openNotification("bottomRight", "error", heading, message);
        setModal2Open(false);
      }
    });
  };

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (placement, type, heading, message) => {
    notification[type]({
      message: heading,
      description: message,
      placement,
    });
  };

  const handleDonorSearch = (e) => {
  const value = e.target.value;
  setGlobalFilterValue(value);
  setSearchQuery(value); // This triggers API call via useEffect
  setCurrentPage(0); // Reset to first page when searching
};


  /*const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
    const filteredData = donations.filter((donation) =>
      Object.keys(donation).some((key) =>
        String(donation[key]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDonations(filteredData);
  };
*/

  //cycle names are retrieved by the api and stored in cycle coloumn
  const loadCycleData = () => {
  allCycles().then((res) => {
    console.log("Cycle API Response:", res); // ✅ See the whole response

    if (res.status === 200) {
      setCycleData(res.data); 
      
      const cycleNamesList = [];
      res.data.forEach((cycle) => {
        cycleNamesList.push(cycle.cycleName);
      });
      setCycleNames(cycleNamesList);

      console.log("Cycle Names List:", cycleNamesList); // ✅ Log extracted names
    }
  });
};


// cycle list comes in the coloumn

  const cycleFilters = cycleData.map(cycle => ({
    text: cycle.cycleName,
    value: cycle.cycleName
  }));


    const columns = [
      {
        title: "Name",
        dataIndex: "donorName",
        key: "donorName",
       sorter: true,
      sortDirections: ['ascend', 'descend'],
      },
      {
        title: "Cycle",
        dataIndex: "cycleName",
        key: "cycleName",
        filters: cycleFilters,
        filteredValue: selectedCycleFilter ? [selectedCycleFilter] : null,
      
      }
      ,
      {
        title: "Donation Type",
        dataIndex: "donationType",
        key: "donationType",
        sorter: true,
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        sorter: true,
      },
      {
        title: "Payment Method",
        dataIndex: "paymentMethod",
        key: "paymentMethod",
       sorter: true,
      },
      {
        title: "Creation Date",
        dataIndex: "creationDate", // Assuming "creationDate" is a valid date field in your data
        key: "creationDate",
        fixed: 'left',
        sorter: true,
        render: (creationDate) => {
          // Access the actual date value
          if (!creationDate) {
            // Handle missing or invalid dates
            return null; // Display nothing or a placeholder
          }
          return moment(creationDate).format("YYYY-MM-DD");
        },
      },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            textAlign: "center",
            justifyContent: "space-between",
          }}
        >
          <Modal
            title="Confirm Deletion"
            centered
            open={modal2Open}
            okText="Delete"
            onOk={() => confirmDelete(currentRecordId)}
            onCancel={() => setModal2Open(false)}
            okButtonProps={{ danger: true }}
            maskProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.2)" } }}
          >
            <p>Are you sure you want to delete this donation.</p>
          </Modal>
          <Tooltip title="Download Receipt" placement="top">
            {isDownloading && record.id === currentRecordId ? (
              <LoadingOutlined style={{ fontSize: "20px"
                
               }} />
            ) : (
              <DownloadOutlined
                className="download-icon"
                
                onClick={() => {
                  setIsDownloading(true);
                  setCurrentRecordId(record.id);
                  donationReceipt(record.id).then((res) => {
                    if (res.status === 200) {
                      downloadDonationReceiptFile(res, record);
                    }
                    setIsDownloading(false);
                  });
                }}
              />
            )}
          </Tooltip>
          <Tooltip title="Edit Donation" placement="top">
            <EditOutlined
              className="edit-icon"
            
              onClick={() => {
                setCurrentRecord(record);
                showDrawer();
                setEditMode(true);
              }}
            />
          </Tooltip>
          <Tooltip title="Delete Donation" placement="top">
            <DeleteOutlined
              className="delete-icon"
             
              onClick={() => {
                setCurrentRecordId(record.id);
                setDonorName(record.donorName);
                setModal2Open(true);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
  const loadAllDonations = () => {
  setIsLoading(true);
 paginatedDonations(currentPage, pageSize,  selectedCycleFilter, sortField, sortDirection, searchQuery)
    .then((res) => {
      if (res.status === 200) {
      const mapped = res.data.content.map((Donation) => ({
        creationDate: Donation.creationDate,
        amount: Donation.amount,
        crNumber: Donation.crNumber,
        donationType: Donation.donationType,
        donorName: Donation.donorId?.userId?.name,
        donorId: Donation.donorId?.id,
        paymentMethod: Donation.paymentMethod,
        id: Donation.id,
        cycleid: Donation.cycleid,
        cycleName: Donation.cycleid?.cycleName || "Cycle Name",
      }));
      setDonations(mapped);
      setFilteredDonations(mapped);
      setTotalCount(res.data.totalElements);
    }
    setIsLoading(false);
  });
};
  
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setEditMode(false);
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  //called loadCycleData in useEffect
useEffect(() => {
  loadAllDonations();
  loadCycleData();
}, [currentPage, pageSize, sortField, sortDirection, selectedCycleFilter, searchQuery]);


  useEffect(() => {
    console.log("THis is called when there is a change in cycleNames state")
  }, [cycleNames]);
  

  

  const leftContents = (
    <React.Fragment>
      <h5 className="mx-0 my-1">Donations</h5>
    </React.Fragment>
  );
  const rightContents = (
    <React.Fragment>
      <span className="mt-2 ml-1 sm:mt-0 sm:ml-0 p-input-icon-left del-con ">
        <span className="p-input-icon-left">
          <i className="pi pi-search mt-1" />
          <Search
            placeholder="Search Donation"
            onChange={handleDonorSearch}
            value={globalFilterValue}
            style={{
              width: 200,
            }}
          />
        </span>
      </span>
      <Button type="primary" onClick={showDrawer} icon={<PlusOutlined />}>
        Add Donation
      </Button>
    </React.Fragment>
  );

const handleTableChange = (pagination, filters, sorter) => {
  if (sorter?.field) {
    setSortField(sorter.field);
    setSortDirection(sorter.order === "ascend" ? "asc" : "desc");
  }

  if (filters?.cycleName) {
    setSelectedCycleFilter(filters.cycleName[0]);// Track selected cycle
    } else {
    setSelectedCycleFilter(null); // 👈 Reset filter 
  }

  if (pagination) {
    setCurrentPage(pagination.current - 1);
    setPageSize(pagination.pageSize);
  }
};



  return (
    <div className="w-[100%] ">
      <Drawer
        title={editMode ? "Edit Donation" : "Add Donation"}
        width={500}
        onClose={onClose}
        open={open}
        styles={{ body: { paddingBottom: 80 } }}
      >
        <DonationForm
          hide={onClose}
          load={loadAllDonations}
          editMode={editMode}
          editorValues={currentRecord}
        />
      </Drawer>
  
      <div className=" p-3 m-1 rounded-[6px] w-[100%]  justify-center sm:w-[100%] md:w-[100%] lg:w-[100%] xl:w-[100%] 2xl:w-[100%]">
        <Toolbar
          style={{ border: "hidden" }}
          left={leftContents}
          right={rightContents}
        />
      </div>
  
      <div
        className=" overflow-scroll w-[90%] ml-10
          2xl:w-[97%] 2xl:h-[80vh]
          xl:w-[90%] xl:h-[80vh] 
          lg:w-[98%] lg:h-[80vh] 
          md:w-[98%] md:h-[80vh] 
          sm:w-[98%] sm:h-[80vh] "
      >
        <div>
          {isloading ? (
            <div className="flex justify-center items-center h-full">
              <Spin size="large" />
            </div>
          ) : (
            
<Table
  dataSource={filteredDonations}
  columns={columns}
  onChange={handleTableChange}
  pagination={{
    current: currentPage + 1,
    pageSize,
    total: totalCount,
    showSizeChanger: true,
  }}
  className="custom-padding-table"
/>
          )}
        </div>
      </div>
    </div>
  );
};

export default Donations;
